import React, { useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import {
  Box,
  Grid,
  Breadcrumbs,
  Stepper,
  Step,
  StepLabel,
  Typography,
  Link as MuiLink
} from "@mui/material";

import { grey } from "@mui/material/colors";
import CheckIcon from '@mui/icons-material/Check';
import { styled } from '@mui/material/styles';
import StepConnector, { stepConnectorClasses } from '@mui/material/StepConnector';

import DefaultLogo from "../../components/layout/DefaultLogo";
import SideBgImage from '../../assets/img/booking-side-bg-01.jpg';

import BookingType from "./createBookingSubs/BookingType";
import BasicInfo from "./createBookingSubs/BasicInfo";
import AppointmentDetail from "./createBookingSubs/AppointmentDetail";
import Screening from "./createBookingSubs/Screening";
import Complete from "./createBookingSubs/Complete";
import { useDispatch, useSelector } from "react-redux";
import { getBookingFormDataByUsername, increaseBookingFormVisitCount } from "../../redux/actions/book";
import { useState } from "react";
import config from "../../config/config";
import "./_flatpickr.scss";

const steps = [
  {
    label: 'Booking Type',
    description: 'Choose your experience.',
    component: BookingType
  },
  {
    label: 'Basic Information',
    description: 'Your basic details.',
    component: BasicInfo
  },
  {
    label: 'Appointment Details',
    description: 'Details of our date.',
    component: AppointmentDetail
  },
  {
    label: 'Screening',
    description: 'Submit screening or verification.',
    component: Screening
  },
  {
    label: 'Complete',
    description: 'Your booking request is sent!',
    component: Complete
  },
];

const ActiveComponent = ({ activeStep, onhandleNext, onhandleBack, length, isPerk }) => {
  const Component = steps[activeStep].component;
  return <Component activeStep={activeStep} onhandleNext={onhandleNext} onhandleBack={onhandleBack} length={length} isPerk={isPerk} />
}

const CreateBookingPage = ({ isPerk }) => {
  const dispatch = useDispatch();
  const { username } = useParams();
  const [activeStep, setActiveStep] = useState(0);
  const [user, setUser] = useState({});
  const [companyLogo, setCompanyLogo] = useState('');

  const { emailNotification } = useSelector(state => ({
    emailNotification: state.book.emailNotification,
  }));

  // useEffect(() => {
  //   if (emailNotification.companyLogo) setCompanyLogo(emailNotification.companyLogo);
  // }, [emailNotification]);

  useEffect(() => {
    onInit();
  }, []);

  const onInit = async () => {
    dispatch(getBookingFormDataByUsername(username));
    const res = await dispatch(increaseBookingFormVisitCount(username));
    setUser({ firstName: res.firstName, lastName: res.lastName });
  }

  useEffect(() => {
    if (emailNotification.companyLogo) {
      setCompanyLogo(`${config.SERVER_BASE_URL}/${emailNotification?.companyLogo}`);
    }
  }, [emailNotification]);

  const onCustomURLCliked = (value) => {
    if (!/^https?:\/\//i.test(value)) {
      value = 'http://' + value;
    }
    window.open(value, "_blank");
  }

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const QontoConnector = styled(StepConnector)(({ theme }) => ({
    marginLeft: '25px',
    [`&.${stepConnectorClasses.alternativeLabel}`]: {
      top: 5,
      left: 'calc(-50% + 16px)',
      right: 'calc(50% + 16px)',
    },
    [`&.${stepConnectorClasses.active}`]: {
      [`& .${stepConnectorClasses.line}`]: {
      },
    },
    [`&.${stepConnectorClasses.completed}`]: {
      [`& .${stepConnectorClasses.line}`]: {
      },
    },
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: '#ccc',
      borderLeftStyle: 'dashed',
      minHeight: '2.5rem',
    },
  }));

  const QontoStepIconRoot = styled('div')(({ theme, ownerState }) => ({
    color: '#fff',
    width: '45px',
    height: '45px',
    display: 'flex',
    fontSize: '18px',
    fontWeight: '600',
    alignItems: 'center',
    justifyContent: 'center',
    border: '1px dashed #ccc',
    borderRadius: '50%',
    ...(ownerState.active && {
      color: '#fff',
      backgroundColor: '#50cd89',
      border: '1px solid #50cd89',
    }),
    '& .QontoStepIcon-completedIcon': {
      color: '#50cd89',
      zIndex: 1,
      fontSize: 20,
    },
  }));
  
  function QontoStepIcon(props) {
    const { active, completed, className, icon } = props;
  
    return (
      <QontoStepIconRoot ownerState={{ active }} className={className}>
        {completed ? <CheckIcon className="QontoStepIcon-completedIcon" /> : icon}
      </QontoStepIconRoot>
    );
  }

  return (
    <Box
      sx={{
        minHeight: '100vh',
        width: '100%'
      }}
    >
      <Grid
        container
        justifyContent='space-between'
        direction='row'
        display='flex'
      >
        <Grid
          item
          container
          direction='column'
          display='flex'
          alignItems='center'
          sm={12}
          sx={{
            backgroundImage: `url(${SideBgImage})`,
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
            backgroundPosition: 'center',
            py: { xs: 2 },
            minHeight: { md: '100vh' },
            maxWidth: { lg: '500px', md: '350px' },
            overflowX: { md: 'scroll', lg: 'hidden' },
            overflowY: 'hidden'
          }}
        >
          <Grid className="user-logo-title" display='flex' justifyContent='center' sx={{ mt: { md: 10, sm: 5 } }}>
            <Link to='/bookings'>
              {emailNotification.companyLogo !== 'uploads/user-logo.png' ?
                <Box
                  component="img"
                  src={companyLogo}
                  sx={{ width: '420px' }}
                /> :
                <DefaultLogo firstName={user?.firstName} lastName={user?.lastName} />
              }
            </Link>
          </Grid>
          <Breadcrumbs aria-label="breadcrumb" separator="●" sx={{ mt: 1.5, color: grey[500], '&:hover': { cursor: 'pointer' } }}>
            {(emailNotification.customLinks || []).map((item, index) => (
              <MuiLink key={index} onClick={() => onCustomURLCliked(item.value)} color='text.primary' underline="none" sx={{ fontSize: '0.8rem' }}>{item.label}</MuiLink>
            ))}
          </Breadcrumbs>
          <Typography sx={{ color: '#fff', fontSize: '20px', fontWeight: 600, display: { md: 'none' }, mt: 1 }}>BOOKING FORM</Typography>
          <Stepper
            orientation="vertical"
            activeStep={activeStep}
            connector={<QontoConnector />}
            sx={{
              display: { xs: 'none', md: 'flex' },
              mt: 6,
              ".MuiStepLabel-root": {
                padding: '0px',
              },
            }}>
            {steps.map((step) => (
              <Step key={step.label}>
                <StepLabel StepIconComponent={QontoStepIcon}>
                  <Typography sx={{ fontSize: '1rem', fontWeight: 500, color: '#fff', marginInlineStart: 1.5 }}>
                    {step.label}
                  </Typography>
                  <Typography sx={{ fontSize: '0.75rem', fontWeight: 400, color: '#ccc', marginInlineStart: 1.5 }}>{step.description}</Typography>
                </StepLabel>
              </Step>
            ))}
          </Stepper>
        </Grid>
        <ActiveComponent activeStep={activeStep} onhandleNext={handleNext} onhandleBack={handleBack} length={steps.length} isPerk={isPerk} />
      </Grid>
    </Box>
  )
}

export default CreateBookingPage;
